<template>
  <footer id="footer">
    <div class="inner">
      <div class="credit-links last">
        <p v-for="(link, index) in creditLinks" :key="['credit',index].join('-')"><a :href="link.to" target="_blank">{{link.content}}</a></p>
      </div>
    </div>
  </footer>
</template>
<script>

export default {
  name: "PageFooter",
  props: {
    footer: {
      type: Object
    }
  },
  computed: {
    creditLinks() {
      if (this.footer instanceof Object) {
        if (this.footer.creditLinks instanceof Array) {
          return this.footer.creditLinks;
        }
      }
      return [];
    }
  },
};
</script>